$('.questions-t .qt[data-type=5]').each(function () {
	$(this).find('.variants:not(.disabled)').sortable({
		update: function () {
			$(this).find('.variant .sort').each(function (i, e) {
				$(e).val(i);
			});

			Lection.cacheHomework();
		}
	});
});